<template>
  <div id="attendance-event">
    <div class="attendance-img-wrapper">
      <div class="apt-image"></div>
      <!-- <img :src="`${$s3}/img/common/mypage/attendance.webp?${$ver}`" class="w-100" /> -->
      <div class="d-grid">
        <div :class="{ seven: i === 7 }" class="attendance_wrap" v-for="i in 7" :key="i">
          <div v-if="i === 7" class="title">7day</div>
          <img v-if="cnt_attendance < i" :src="`${$s3}/img/common/mypage/coupon${atdcImgNum(i, 0)}.svg?${$ver}`" />
          <img
            v-else
            :src="`${$s3}/img/common/mypage/coupon${atdcImgNum(i, 0)}_active${atdcImgNum(i, 1)}.svg?${$ver}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttendanceComponent',
  props: ['cnt_attendance'],
  methods: {
    atdcImgNum(num, position) {
      if (position === 0) {
        switch (num) {
          case 7:
            return 's';

          default:
            return '';
        }
      } else if (position === 1) {
        switch (num) {
          case 2:
          case 5:
            return '1';
          case 3:
          case 6:
            return '2';

          default:
            return '';
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#attendance-event {
  margin: 0;
  padding: 20px 24px 0 24px;
  text-align: center;

  .block-content {
    padding: 0;
  }
  .row {
    margin: 0 -4px;
  }
  #attendance_title {
    font-size: 16px;
    color: #001c41;
    font-weight: 600;
    margin-bottom: 10px;
  }
  #attendance_subtitle {
    font-size: 13px;
    margin-bottom: 3px;
    color: #333333;
  }
  .attendance_block {
    padding: 0;
    border: 1px solid #ededed;
  }
  img {
    width: 100%;
  }
  #attendance_info {
    color: #666666;
    font-size: 10px;
    text-align: left;
    margin-top: 12px;
  }
  .attendance-img-wrapper {
    display: grid;
    grid-template-columns: 1.5fr 3fr;

    .apt-image {
      width: 100%;
      background: bottom / contain no-repeat url($s3-url + '/img/common/mypage/attendance.webp?' + $version), #2659cc;
    }

    .d-grid {
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, 1fr) 1.2fr;
      border: 0.5px solid #ededed;
      border-left: 0;

      .attendance_wrap {
        position: relative;
        display: grid;
        place-items: center;
        border: 0.5px solid #ededed;
        padding: 0.5rem;

        &:not(.seven) {
          aspect-ratio: 1;
        }

        &.seven {
          grid-column: 1 / span 3;
          padding: 0.5rem;
        }

        .title {
          font-size: 10px;
          color: #fff;
          background: #000;
          position: absolute;
          padding: 3px 7px;
          padding-bottom: 3px !important;
          top: 4px;
          left: 0;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
